const week = 1000 * 60 * 60 * 24 * 7;

export const weekWindow = (ms: number) => {
  if (ms < -3 * week) {
    return "Over three weeks since Effective Date";
  }

  if (ms < 3 * week) {
    return "Close to Effective Date";
  }

  return "Over three weeks to Effective Date";
};
